import React from 'react';
import Traiteur from '../Traiteur';

function TraiteurPage() {
    return (
        <>
            <Traiteur />
        </>
    )
}

export default TraiteurPage;
